import React from 'react';
import Select from "react-select";
import IconDownload from '../../../../icons/download';
import { connect } from 'react-redux';
import { downloadTemplate } from '../../../../../redux/modules/vendors';


const Filters = (props) => {
    const {
        onChange,
        onExportCsv,
        onExportExcel,
        downloadTemplate,
        filters={}
    } = props;

    const downloadCsvTemplate = () => {
        downloadTemplate('csv')
    }

    const downloadExcelTemplate = () => {
        downloadTemplate('excel')
    }

    return (
        <div className="d-flex justify-content-between">
            <div className="d-flex" style={{ gap: 8 }}>
                <input
                    type="search"
                    className="form-control h6 mb-0"
                    placeholder="Search by name or email..."
                    value={filters.search}
                    onChange={(e)=>{
                        onChange({...filters, search: e.target.value})
                    }}
                />
                <Select
                    searchable
                    clearable={false}
                    className=""
                    labelKey="label"
                    valueKey="value"
                    options={[
                        { label: "All", value: "all" },
                        { label: "Account Admin", value: "account_admin" },
                        { label: "Driver", value: "driver" },
                    ]}
                    placeholder="All Roles"
                    onChange={(e) => {
                        onChange({...filters, role: e.value});
                    }}
                    value={filters.role}
                    menuContainerStyle={{ fontSize: '1rem' }}
                    style={{ height: "100%", minWidth: 170, fontSize: '1rem' }}
                />
                <Select
                    searchable
                    clearable={false}
                    className=""
                    labelKey="label"
                    valueKey="value"
                    options={[
                        { label: "All Status", value: "all" },
                        { label: "Active", value: "active" },
                        { label: "Inactive", value: "inactive" },
                    ]}
                    placeholder="All status"
                    onChange={(e) => {
                        onChange({...filters, status: e.value});
                    }}
                    value={filters.status}
                    menuContainerStyle={{ fontSize: '1rem' }}
                    style={{ height: "100%", minWidth: 150, fontSize: '1rem' }}
                />
            </div>
            <div className="d-flex" style={{ gap: 8 }}>
                <div className="dropdown">
                    <button type="button"
                        className="btn btn-outline-secondary dropdown-toggle" 
                        data-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <IconDownload className="vendor-icon" />
                        <span className="h6 mb-0 ml-2 fw-600">Export</span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item clickable"
                            onClick={onExportCsv}
                        >
                            <i className="fa fa-file-text-o" />
                            <span className="h6 mb-0 ml-2">
                                Export as CSV
                            </span>
                        </a>
                        <a className="dropdown-item clickable"
                            onClick={onExportExcel}
                        >
                            <i className="fa fa-file-excel-o" />
                            <span className="h6 mb-0 ml-2">
                                Export as Excel
                            </span>
                        </a>
                    </div>
                </div>
                <div className="dropdown">
                    <button type="button"
                        className="btn btn-outline-primary dropdown-toggle" 
                        data-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i className="fa fa-file-o mr-1" />
                        <span className="h6 mb-0 ml-2 fw-600">Templates</span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item clickable"
                            onClick={downloadCsvTemplate}
                        >
                            <IconDownload className="vendor-icon" />
                            <span className="ml-2">
                                CSV Template
                            </span>
                        </a>
                        <a className="dropdown-item clickable"
                            onClick={downloadExcelTemplate}
                        >
                            <IconDownload className="vendor-icon" />
                            <span className="ml-2">
                                Excel Template
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mdtp = {
    downloadTemplate,
}

export default connect(null, mdtp)(Filters);
